import { Section } from '@telegram-apps/telegram-ui';
import { TelegramTitle } from '../../components/shared/TelegramTitle';
import { RovignetteForm } from './RovignetteForm';
import { useLanguage } from '../../LanguageProvider';

export const Rovignette = () => {
  const { translate, setLanguage, language } = useLanguage();

  return (
    <>
      <div style={{ background: 'var(--tgui--secondary_bg_color)' }}>
        <TelegramTitle
          title={translate('rovignette-form:title')}
          subtitle={translate('rovignette-form:subtitle')}
        />
        <RovignetteForm />
      </div>
    </>
  );
};
